import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    expandedCustomerIds: [],
    reportDate: new Date(),
    filteredCustomerIds: [],
};
const customerDebtReportSlice = createSlice({
    name: 'customerDebtReport',
    initialState,
    reducers: {
        setExpandedCustomerIds: (state, action) => {
            state.expandedCustomerIds = [...action.payload];
        },
        addExpandedCustomerId: (state, action) => {
            state.expandedCustomerIds.push(action.payload);
        },
        deleteExpandedCustomerId: (state, action) => {
            state.expandedCustomerIds = state.expandedCustomerIds.filter((id) => id !== action.payload);
        },
        setFilteredCustomerIds: (state, action) => {
            state.filteredCustomerIds = [...action.payload];
        },
        setReportDate: (state, action) => {
            state.reportDate = action.payload;
        },
    },
});
export const { actions: customerDebtReportActions, reducer: customerDebtReportReducer } = customerDebtReportSlice;
